<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Launcher Management</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/launcher/activation-policy' }">Activation Policies</el-breadcrumb-item>
                <el-breadcrumb-item>Manage Policy</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="16">
                <div class="main-title">
                    Policy Detail
                </div>

            </el-col>
            <el-col :span="8" class="text-right">
                <el-button type="success" size="small" :disabled="!hasUpdate" @click="updatePolicy">Update Policy</el-button>
            </el-col>
        </el-row>
        <el-row :gutter=20 type="flex" justify="space-between" class="mb-4" style="margin-top: 24px">

            <el-col :span="12" v-loading="loading">
                <div class="container">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>Activation Policy Detail</span>
                        </div>
                        <div  class="text item">
                            <el-table
                                    :show-header="false"
                                    :data="detailData"
                                    style="width: 100%">
                                <el-table-column
                                        prop="key"
                                        label="key"
                                        class-name="font-bold"
                                        width="180">
                                </el-table-column>
                                <el-table-column
                                        prop="value"
                                        label="Value">
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-card>
                </div>
                <div class="container mt-5" >
                    <el-card class="box-card">
                        <div  class="text item">
                            <el-form>
                                <el-form-item label="Remarks">
                                    <el-input
                                            type="textarea"
                                            :rows="2"
                                            placeholder="Please input"
                                            v-model="form.remarks">
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-card>
                </div>
            </el-col>
            <el-col :span="12"  v-loading="loading">

                <div class="container">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>Step Mandatory Setting</span>
                        </div>
                        <div class="text item">
                            <h4>Current Policy</h4> <br/>
                            <p class="text-sm">Setting the step to mandatory means customer must complete the required information in the respective
                            session before they can start using Super Reader</p> <br />
<!--                            <p>{{form.step2}} - {{policy.step2Mandatory}}</p>-->
                            <el-form>
                                <el-form-item>
                                    <el-col :span="24"  > Step 2 - User Registration<el-switch class="ml-3" v-model="form.step2"></el-switch>  </el-col>
                                    <el-col :span="24"  > Step 3 - Parent Mode Password Setup <el-switch class="ml-3" v-model="form.step3"></el-switch>  </el-col>
                                </el-form-item>

                            </el-form>
                        </div>
                        <div class="text item border-t">
                            <div class="mt-4" >
                                <h4 ><el-switch class="mr-3" v-model="form.future"></el-switch> Future Policy</h4> <br/>

                            </div>
                            <el-form :rules="futureRule" ref="futureForm" :model="form">
                                <el-form-item class="mt-1" prop="futureDate">
                                    <el-date-picker
                                            style="width: 100%"
                                            v-model="form.futureDate"
                                            type="date"
                                            placeholder="Pick a day"
                                            @change="dateChanged = true"
                                            :picker-options="pickerOptions">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item >
                                    <el-col :span="24"  > Step 2 - User Registration <el-switch class="ml-3" v-model="form.futureStep2"></el-switch>  </el-col>
                                    <el-col :span="24"  > Step 3 - Parent Mode Password Setup <el-switch class="ml-3" v-model="form.futureStep3"></el-switch>  </el-col>
                                </el-form-item>

                            </el-form>
                        </div>
                    </el-card>
                </div>

            </el-col>
        </el-row>
        <el-row type="flex" style="margin-top:24px" v-loading="loadingRecords">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>Activation Policy History Record</span>
                    </div>
                    <div class="text item">
                        <el-table
                                :data="records"
                                stripe
                                style="width: 100%">
                            <el-table-column
                                    prop="policyId"
                                    label="Policy ID">
                            </el-table-column>
                            <el-table-column
                                    width="80"
                                    prop="step2"
                                    label="Step 2">
                                <template slot-scope="scope">
                                    <i :class="{'text-xl el-icon-check text-green' : scope.row.step2Mandatory, 'text-xl el-icon-close text-red' : !scope.row.step2Mandatory}"></i>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    width="80"
                                    prop="step3"
                                    label="Step 3" class="">
                                <template slot-scope="scope" >
                                    <i :class="{'text-xl el-icon-check text-green' : scope.row.step3Mandatory, 'text-xl el-icon-close text-red' : !scope.row.step3Mandatory}"></i>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="createdBy"
                                    label="By">
                            </el-table-column>
                            <el-table-column
                                    label="Date">
                                <template slot-scope="scope" >
                                    {{scope.row.createdDate | formatDate}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="remarks"
                                    label="Remarks">
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </el-main>
</template>

<script>
import _ from 'lodash'
import api from '@/services/api/WRCService'
import moment from 'moment'

export default {
    props: ['policyId'],
    data: function() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                }
            },
            loadingRecords: false,
            loading: false,
            future: false,
            dateChanged: false,
            policy: '',
            records: [],
            detailData:[
                {key: "Country", value: "-"},
                {key: "Policy ID", value: "-"},
                {key: "Last Updated", value: "-"},
                {key: "By", value: "-"},
                {key: "Remarks", value: "-"},
            ],
            form: {
                step2: true,
                step3: true,
                future: false,
                futureStep2: false,
                futureStep3: false,
                futureDate: '',
                remarks: ''
            }
        }
    },
    computed: {
        futureRule() {
            return {
                futureDate: [
                    {required: this.form.future, message: "Please select date", trigger: 'blur'}
                ],
            }
        },
        hasUpdate() {
            let futureChanged = this.form.future !== this.policy.futurePolicy

            if (futureChanged) {
                return true
            }

            if (this.form.future) {
                let step2Changed = this.form.futureStep2 !== this.policy.futureStep2Mandatory
                let step3Changed = this.form.futureStep3 !== this.policy.futureStep3Mandatory
                return step2Changed || step3Changed || this.dateChanged
            }

            if (this.policy.activeRecord) {
                let step2Changed = this.form.step2 !== this.policy.activeRecord.step2Mandatory
                let step3Changed = this.form.step3 !== this.policy.activeRecord.step3Mandatory
                return step2Changed || step3Changed
            } else {
                return true
            }
        }
    },
    methods: {
        updatePolicy() {
            this.$refs['futureForm'].validate((valid) => {

                if (!this.form.future || valid) {
                    let params = {
                        policyId: this.policyId,
                        remarks: this.form.remarks,
                        step2Mandatory: this.form.step2,
                        step3Mandatory: this.form.step3,
                    }

                    if (this.form.future) {
                        params.futurePolicy = true
                        params.futureStep2Mandatory = this.form.futureStep2
                        params.futureStep3Mandatory = this.form.futureStep3
                        params.futurePolicyActivation = this.form.futureDate
                    }

                    this.loading = true

                    api.updateActivationPolicy(params).then(({data}) => {
                        this.$message({
                            message: 'Successfully Updated Policy.',
                            type: 'success'
                        })

                        this.$router.push('/launcher/activation-policy')
                    }).catch(() => {
                    }).then(() => {
                        this.loading = false
                    })
                }
            })
        }
    },
    mounted() {
        if (!_.isUndefined(this.policyId)) {
            this.loading = true

            api.getPolicy(this.policyId).then(({data}) =>{
                this.policy = data.data

                let policyId = this.policy.activeRecord ? this.policy.activeRecord.policyId : ' - ';
                let remarks = this.policy.activeRecord ? this.policy.activeRecord.remarks : ' - ';
                let lastUpdate = this.policy.lastUpdatedDate ? this.policy.lastUpdatedDate : ' - ';
                let lastModifiedBy = this.policy.lastModifiedBy ? this.policy.lastModifiedBy : ' - ';

                lastUpdate = moment(lastUpdate).format('MM/DD/YYYY')

                this.detailData = [
                    {key: "Country", value: this.policy.country.name},
                    {key: "Policy ID", value: policyId},
                    {key: "Last Updated", value: lastUpdate},
                    {key: "By", value: lastModifiedBy},
                    {key: "Remarks", value: remarks},
                ]

                if (this.policy.activeRecord) {
                    this.form.step2 = this.policy.activeRecord.step2Mandatory
                    this.form.step3 = this.policy.activeRecord.step3Mandatory
                }

                this.form.future = this.policy.futurePolicy
                this.form.futureStep2 = this.policy.futureStep2Mandatory
                this.form.futureStep3 = this.policy.futureStep3Mandatory

                if (this.policy.futurePolicyDate) {
                    this.form.futureDate = moment(this.policy.futurePolicyDate).toDate()
                }
            }).catch(() => {}).then(() => {
                this.loading = false
            })

            this.loadingRecords = true;

            api.getPolicyRecords(this.policyId, {
                page: 0,
                size: 100
            }).then(({ data }) => {

                this.records.splice(0, this.records.length);
                this.records.push(...data.data.items);
            }).catch(() => {}).then(() => {
                this.loadingRecords = false;
            });
        }
    }
}
</script>

<style scoped>
</style>